/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfiguredPayor } from './ConfiguredPayor';
import {
    ConfiguredPayorFromJSON,
    ConfiguredPayorFromJSONTyped,
    ConfiguredPayorToJSON,
    ConfiguredPayorToJSONTyped,
} from './ConfiguredPayor';

/**
 * 
 * @export
 * @interface FacilityPayorConfig
 */
export interface FacilityPayorConfig {
    /**
     * The facility ID
     */
    facility_id?: string;
    /**
     * Configured payors for this facility with allowed insurance types
     */
    configured_payors?: Array<ConfiguredPayor>;
}

/**
 * Check if a given object implements the FacilityPayorConfig interface.
 */
export function instanceOfFacilityPayorConfig(value: object): value is FacilityPayorConfig {
    return true;
}

export function FacilityPayorConfigFromJSON(json: any): FacilityPayorConfig {
    return FacilityPayorConfigFromJSONTyped(json, false);
}

export function FacilityPayorConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityPayorConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'configured_payors': json['configured_payors'] == null ? undefined : ((json['configured_payors'] as Array<any>).map(ConfiguredPayorFromJSON)),
    };
}

export function FacilityPayorConfigToJSON(json: any): FacilityPayorConfig {
    return FacilityPayorConfigToJSONTyped(json, false);
}

export function FacilityPayorConfigToJSONTyped(value?: FacilityPayorConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'configured_payors': value['configured_payors'] == null ? undefined : ((value['configured_payors'] as Array<any>).map(ConfiguredPayorToJSON)),
    };
}

